import Request from '../index';
import STORAGE_NAME from '@/const/storage';

const accountRequest = new Request();
let token = localStorage.getItem(STORAGE_NAME.ACCESS_TOKEN);
let storeDomain = localStorage.getItem(STORAGE_NAME.STORE_DOMAIN) || 'accounts.dropnoxe.com';
if (storeDomain) {
  accountRequest.setBaseURL('https://' + storeDomain + '/api/');
}
if (token) {
  accountRequest.setToken(token);
}
export default accountRequest;
